export const WORKSPACE_SIDEBAR_HOTKEYS_SCOPE = 'workspace-sidebar';

export enum WorkspaceSidebarToken {
  Hamburger = 'workspace-sidebar-hamburger',
  Notifications = 'notifications',
  CloseAfterNotifications = 'close-after-notifications',
}
